import { Box, Image, Carousel, LucideIcon } from '@skin-seoul/design-system';
import type { ReviewImage } from '..';
interface ReviewCardImageCarouselProps {
  images: ReviewImage[];
  width: string;
  height: string;
  onImageClick: (image: ReviewImage, index: number) => void;
}
export const ReviewCardImageCarousel = ({
  images,
  width,
  height,
  onImageClick
}: ReviewCardImageCarouselProps) => {
  return <Box w={width} h={height} borderRadius="8px" overflow="hidden" flexShrink={0} data-sentry-element="Box" data-sentry-component="ReviewCardImageCarousel" data-sentry-source-file="ReviewCardImageCarousel.tsx">
      <Carousel w="full" h="full" opts={{
      loop: true,
      align: 'center'
    }} data-sentry-element="Carousel" data-sentry-source-file="ReviewCardImageCarousel.tsx">
        <Carousel.Content w="full" h="full" data-sentry-element="Carousel.Content" data-sentry-source-file="ReviewCardImageCarousel.tsx">
          {images.map((image, index) => <Carousel.Item key={image.id}>
              <Box w={width} h={height} bg="generic.0" display="flex" alignItems="center" justifyContent="center">
                <Image w="full" h="full" src={image.url} alt={image.alt} objectFit="cover" cursor="pointer" onClick={() => onImageClick(image, index)} />
              </Box>
            </Carousel.Item>)}
        </Carousel.Content>
        {images.length > 1 && <>
            <Carousel.Previous left="8px" w="32px" h="32px" minW="32px" minH="32px" borderRadius="50%" bg="rgba(247, 247, 249, 0.2)" backdropFilter="blur(8px)" border="none" _hover={{
          bg: 'rgba(247, 247, 249, 0.4)'
        }}>
              <LucideIcon name="ChevronLeft" w="24px" h="24px" color="neutral.50" />
            </Carousel.Previous>
            <Carousel.Next right="8px" w="32px" h="32px" minW="32px" minH="32px" borderRadius="50%" bg="rgba(247, 247, 249, 0.2)" backdropFilter="blur(8px)" border="none" _hover={{
          bg: 'rgba(247, 247, 249, 0.4)'
        }}>
              <LucideIcon name="ChevronRight" w="24px" h="24px" color="neutral.50" />
            </Carousel.Next>
            <Carousel.Dots position="absolute" bottom="8px" left="50%" transform="translateX(-50%)" gap="2px" p="8px" borderRadius="23px" bg="rgba(247, 247, 249, 0.2)" backdropFilter="blur(16px)" renderDot={({
          onClick,
          isSelected,
          index
        }: {
          onClick: () => void;
          isSelected: boolean;
          index: number;
        }) => <Box key={index} w={isSelected ? '20px' : '4px'} h="4px" borderRadius="4px" bg={isSelected ? '#ffffff' : '#c4c4c4'} transition="all 0.2s ease" cursor="pointer" onClick={onClick} />} />
          </>}
      </Carousel>
    </Box>;
};
export default ReviewCardImageCarousel;